module.exports = __webpack_public_path__ + "img/firefox.d61c1e58.gif";